import {
    configureFormatLargeAmountCurrency,
    getCurrency,
    getCurrencySymbolPosition,
    getNumberAsCurrency,
    getStringAsCurrency,
    setupCurrencyLocaleUser,
} from '@Sage/ssm-utils';

import { formatLargeAmountCurrency } from 'utils/amount';

configureFormatLargeAmountCurrency(formatLargeAmountCurrency);

export { getCurrency, getCurrencySymbolPosition, getStringAsCurrency, setupCurrencyLocaleUser };

export { getNumberAsCurrency };
